import { RedocStandalone } from 'redoc';

import colors from './colors';
import versions from './yaml';

function App() {
  const theme = {
    codeBlock: {
      backgroundColor: colors.rightPanelBlockBackground
    },
    colors: {
      border: {
        dark: colors.borderLight
      },
      gray: {
        50: colors.gray50,
        100: colors.gray100
      },
      primary: {
        dark: colors.text,
        light: colors.textSecondary
      },
      responses: {
        error: {
          backgroundColor: colors.responseErrorBackground,
          color: colors.text,
          tabTextColor: colors.responseErrorTab
        },
        success: {
          backgroundColor: colors.responseSuccessBackground,
          color: colors.text,
          tabTextColor: colors.responseSuccessTab
        } 
      },
      text: {
        primary: colors.text,
        secondary: colors.textSecondary
      }
    },
    rightPanel: {
      backgroundColor: colors.rightPanelBackground,
      textColor: colors.rightPanelText
    },
    sidebar: {
      activeTextColor: colors.sidebarActiveText,
      arrow: {
        color: colors.text,
        size: '1.25em'
      },
      backgroundColor: colors.sidebarBackground,
      textColor: colors.text
    },
    spacing: {
      sectionHorizontal: 25,
      sectionVertical: 20,
      unit: 10
    },
    typography: {
      code: {
        backgroundColor: 'transparent',
        color: colors.text
      },
      headings: {
        fontFamily: 'Roboto, sans-serif',
        fontWeight: '600'
      },
      links: {
        color: colors.link,
        visited: colors.link,
        hover: colors.linkHover
      }
    }
  };

  const redocOptions = {
    hideDownloadButton: true,
    pathInMiddlePanel: true,
    theme
  };
  return <RedocStandalone spec={versions[0].yaml} options={redocOptions} />;
}

export default App;
